import {
  Box,
  DeleteIcon,
  Div,
  EditPenIcon,
  H5,
  Icon,
  IncidentMessage,
  lightTheme,
  P,
  Pill,
  vDriveStatuses,
} from '@vgrubs/components';
import styled from 'styled-components';
import {
  foodRatingPill,
  isFoodRatingMessage,
  runningLatePill,
} from './incidentMessageRules';

type Props = {
  message: IncidentMessage;
  onEdit: () => void;
  onDelete: () => void;
};

export const IncidentMessageCard = ({ message, onEdit, onDelete }: Props) => {
  // Running-late and food-rating messages have no status, so they wear their own pill.
  const pill = message.status
    ? vDriveStatuses[message.status]
    : isFoodRatingMessage(message)
    ? foodRatingPill()
    : runningLatePill();

  return (
    <Box $p="16px" $animated>
      <Div $flex $alignCenter $between $borderBottom $p="0 0 16px 0">
        <Pill $background={pill.color}>
          <P $m="0" $color="white">
            {pill.name}
          </P>
        </Pill>

        <Div $flex $alignCenter $gap="10px">
          <Icon
            $color={lightTheme.primary}
            $size="32"
            $pointer
            onClick={onEdit}
          >
            <EditPenIcon
              backgroundColor={lightTheme.darkGray}
              iconColor={lightTheme.white}
            />
          </Icon>
          <Icon
            $color={lightTheme.primary}
            $size="32"
            $pointer
            onClick={onDelete}
          >
            <DeleteIcon />
          </Icon>
        </Div>
      </Div>
      <Div $p="16px 0 0 0" $flex $column>
        <H5 $m="0" $mb="8">
          Message
        </H5>
        <MessageText $m="0">{message.message}</MessageText>
      </Div>
    </Box>
  );
};

const MessageText = styled(P)`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;
